'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _slickCarousel = require('slick-carousel');

var _slickCarousel2 = _interopRequireDefault(_slickCarousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
	(function (Sliders, $) {
		var $dom = {};
		var cacheDom = function cacheDom() {
			$dom.productSliderFor = $('[data-slider-for]');
			$dom.productSliderNav = $('[data-slider-nav]');
			$dom.offerSlider = $('[data-home-slider]');
			$dom.brandSlider = $('[data-brand-slider]');
			$dom.popularSlider = $('[data-popular-slider]');
			$dom.bestSlider = $('[data-best-slider]');
			$dom.compareSlider = $('[data-slider-compare]');
		};
		var ProductCompareSlidersForInit = function ProductCompareSlidersForInit() {
			var ProductCompareSliderForOptions = {
				dots: false,
				arrows: false,
				infinite: false,
				speed: 300,
				slidesToShow: 4,
				slidesToScroll: 1,
				responsive: [{
					breakpoint: 1200,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 1
					}
				}, {
					breakpoint: 992,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1
					}
				}, {
					breakpoint: 600,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}]
			};

			$dom.compareSlider.length > 0 && $dom.compareSlider.slick(ProductCompareSliderForOptions);
		};

		var ProductSlidersForInit = function ProductSlidersForInit() {
			var ProductSliderForOptions = {
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				dots: false,
				fade: true,
				centerMode: false,
				asNavFor: ".g-slider-nav"
			};

			$dom.productSliderFor.length > 0 && $dom.productSliderFor.slick(ProductSliderForOptions);
		};

		var ProductSliderNavInit = function ProductSliderNavInit() {
			var ProductSliderNavOptions = {
				slidesToShow: 6,
				slidesToScroll: 1,
				asNavFor: ".g-slider-for",
				arrows: false,
				dots: false,
				centerMode: false,
				focusOnSelect: true,
				responsive: [{
					breakpoint: 1199,
					settings: {
						slidesToShow: 5,
						slidesToScroll: 1
					}
				}, {
					breakpoint: 992,
					settings: {
						slidesToShow: 5,
						slidesToScroll: 1
					}
				}]
			};

			$dom.productSliderNav.length > 0 && $dom.productSliderNav.slick(ProductSliderNavOptions);
		};

		var MobileSlidersInit = function MobileSlidersInit() {
			var offerSliderOptions = {
				dots: true,
				arrows: true,
				infinite: true,
				autoplaySpeed: 3500,
				centerPadding: '40px'
			};

			$dom.offerSlider.length > 0 && $dom.offerSlider.slick(offerSliderOptions);
		};
		var bestSliderOptions = function bestSliderOptions() {
			var bestSliderOptionsEvent = {
				dots: false,
				infinite: false,
				speed: 300,
				slidesToShow: 6,
				slidesToScroll: 1,
				responsive: [{
					breakpoint: 1200,
					settings: {
						slidesToShow: 5,
						slidesToScroll: 1
					}
				}, {
					breakpoint: 992,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 1
					}
				}, {
					breakpoint: 600,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1
					}
				}, {
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}]
			};

			$dom.bestSlider.length > 0 && $dom.bestSlider.slick(bestSliderOptionsEvent);
		};
		var popularSlidersInit = function popularSlidersInit() {
			var popularSliderOptions = {
				dots: false,
				infinite: false,
				speed: 300,
				slidesToShow: 6,
				slidesToScroll: 1,
				responsive: [{
					breakpoint: 1200,
					settings: {
						slidesToShow: 5,
						slidesToScroll: 1
					}
				}, {
					breakpoint: 992,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 1
					}
				}, {
					breakpoint: 600,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1
					}
				}, {
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}]
			};

			$dom.popularSlider.length > 0 && $dom.popularSlider.slick(popularSliderOptions);
		};

		var indexBrandSliderInit = function indexBrandSliderInit() {
			var brandSliderOptions = {
				dots: false,
				arrows: false,
				infinite: false,
				speed: 300,
				slidesToShow: 7,
				slidesToScroll: 1,
				responsive: [{
					breakpoint: 1200,
					settings: {
						slidesToShow: 6,
						slidesToScroll: 1
					}
				}, {
					breakpoint: 992,
					settings: {
						slidesToShow: 5,
						slidesToScroll: 1
					}
				}, {
					breakpoint: 600,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1
					}
				}, {
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}]
			};

			$dom.brandSlider.length > 0 && $dom.brandSlider.slick(brandSliderOptions);
		};

		Sliders.init = function () {
			cacheDom();
			$(window).on('load', function () {
				ProductSlidersForInit();
				ProductSliderNavInit();
				MobileSlidersInit();
				indexBrandSliderInit();
				popularSlidersInit();
				ProductCompareSlidersForInit();
				bestSliderOptions();
			});
			$(window).resize(function () {
				ProductSlidersForInit();
				ProductSliderNavInit();
				MobileSlidersInit();
				indexBrandSliderInit();
				popularSlidersInit();
				bestSliderOptions();
				ProductCompareSlidersForInit();
			});
		};
	})(window.Sliders = window.Sliders || {}, _jquery2.default, undefined);
};